import React from 'react';
import StockSummary from '../features/marketData/stockData/stock-summary';

function StockPage() {
  return (
    <div className='flex flex-col lg:flex-row w-full overflow-y-auto'>

      <div className='flex grow overflow-y-auto'>
        <StockSummary />
      </div>

    </div>
  );
}

export default StockPage;
